import { render, staticRenderFns } from "./remote-inline-svg.vue?vue&type=template&id=c266e930&"
import script from "./remote-inline-svg.js?vue&type=script&lang=js&"
export * from "./remote-inline-svg.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports